import React, { useEffect } from "react";
import { Link } from "@quintype/components";
import Logo from "../../../atoms/icons/logo";
import CokHeaderRight from "./cok-header-right";
import "./cok-header.m.css";
import CokLogo from "../../../atoms/other-icons/CokLogo";
import { get } from "lodash";
import { useSelector } from "react-redux";
import StickyNavbar from "../../../molecules/sticky-navbar";
import HamburgerMenus from "../hamburger-menus";

const CokHeader = ({ navRef, isSticky, toggleHandler }) => {
  const getState = useSelector((state) => state);
  const menus = get(getState, ["qt", "data", "navigationMenu", "cokMenus"], []);

  useEffect(() => {
    if (window !== undefined) {
      const topbar = window.document.querySelector("#topbar");
      const topbarContainer = window.document.querySelector(".top-bar-container");
      const container = window.document.querySelector("#container");

      if (window.innerWidth < 767) {
        if (topbar) topbar.style.minHeight = "116px";
        if (topbarContainer) topbarContainer.style.minHeight = "116px";
        if (container) container.style.paddingTop = "116px";
      }

      return () => {
        if (container) container.style.paddingTop = "";
      };
    }
  }, []);

  return (
    <>
      <div styleName="header">
        <div ref={navRef} styleName={`primary-hardcode ${isSticky ? "extra-index" : ""}`} id="desk-header">
          <div className="container" styleName="primary-wrapper">
            <div styleName="logo-wrapper">
              <Link href="/">
                <Logo width="78" height="68" />
              </Link>
              {/* <div style={{ display: isSticky ? "flex" : "none" }}>
                <HamburgerNotification />
              </div> */}
            </div>
            <Link styleName="cok-logo" href="/cuisines-of-karnataka">
              <CokLogo />
            </Link>
            <div styleName="primary-right-wrapper">
              <CokHeaderRight />
            </div>
          </div>
        </div>

        <div styleName="secondary" style={{ display: !isSticky ? "block" : "none" }}>
          <div className="container" styleName="secondary-wrapper">
            {menus.map((menu) => (
              <Link href={menu.url} id={menu.id}>
                <span styleName="menu">{menu.title}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
      <HamburgerMenus />
      <StickyNavbar onMenuToggle={() => toggleHandler()} />
    </>
  );
};

export default CokHeader;
